import { render, staticRenderFns } from "./UrunTopluGuncelle.vue?vue&type=template&id=1d958eae&scoped=true"
import script from "./UrunTopluGuncelle.vue?vue&type=script&lang=js"
export * from "./UrunTopluGuncelle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d958eae",
  null
  
)

export default component.exports